var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 55 53",
    style: {
      enableBackground: "new 0 0 55 53"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#023047;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,52.3c0,0-3.4,0-3.4-3.4c0-3.4,3.4-13.8,17.2-13.8s17.2,10.3,17.2,13.8c0,3.4-3.4,3.4-3.4,3.4H13.8z  M27.5,31.8c2.3,0,4.5-0.9,6.1-2.5c1.6-1.6,2.5-3.8,2.5-6.1s-0.9-4.5-2.5-6.1c-1.6-1.6-3.8-2.5-6.1-2.5s-4.5,0.9-6.1,2.5 c-1.6,1.6-2.5,3.8-2.5,6.1s0.9,4.5,2.5,6.1C23,30.9,25.2,31.8,27.5,31.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.9,0.7c-1.8,0-3.6,0.7-4.9,2C0.7,4,0,5.8,0,7.6v32.7c0,1.4,0.5,2.7,1.5,3.6c1,1,2.3,1.5,3.6,1.5h2.2 c0.7-2.5,2-4.9,3.7-6.9H3.4V7.6c0-0.9,0.4-1.8,1-2.4s1.5-1,2.4-1h41.3c0.9,0,1.8,0.4,2.4,1c0.6,0.6,1,1.5,1,2.4v30.9h-7.6 c1.9,2.2,3.1,4.7,3.7,6.9h2.2c1.4,0,2.7-0.5,3.6-1.5s1.5-2.3,1.5-3.6V7.6c0-1.8-0.7-3.6-2-4.9c-1.3-1.3-3-2-4.9-2H6.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.54501ff51afb3d5d513d10cad8353381.svg";
export { ForwardRef as ReactComponent };